import axios from 'axios';
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const instanciaAPI = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Adiciona token no header de todas as requisições
instanciaAPI.interceptors.request.use((config) => {
  const token = Cookies.get('token_autenticacao');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fazerLogin = async (nome, senha) => {
  try {
    const resposta = await instanciaAPI.post('/auth/login', { nome, senha });
    return resposta.data;
  } catch (erro) {
    const detalhe = erro?.response?.data?.error || erro?.message || JSON.stringify(erro);
    console.error('fazerLogin erro:', detalhe);
    throw detalhe || 'Erro ao fazer login';
  }
};

export const baixarVideo = async (url) => {
  try {
    const resposta = await instanciaAPI.post('/download', { url }, {
      responseType: 'blob',
    });
    return resposta.data;
  } catch (erro) {
    const detalhe = erro?.response?.data?.error || erro?.message || JSON.stringify(erro);
    console.error('baixarVideo erro:', detalhe);
    throw detalhe || 'Erro ao baixar vídeo';
  }
};

export const obterVideoPrevia = async (url) => {
  try {
    const resposta = await instanciaAPI.post('/download', { url }, {
      responseType: 'blob',
    });
    console.log('obterVideoPrevia resposta:', resposta);
    // Cria URL de visualização
    const urlObjeto = URL.createObjectURL(resposta.data);
    return { url: urlObjeto, blob: resposta.data };
  } catch (erro) {
    const detalhe = erro?.response?.data?.error || erro?.message || JSON.stringify(erro);
    console.error('obterVideoPrevia erro:', detalhe);
    throw detalhe || 'Erro ao obter prévia do vídeo';
  }
};

export default instanciaAPI;
